<template>
    <!-- 管理员- 回顾管理 -->
    <div class="reivew wrapper">
        <proTitle></proTitle>
        <el-form :inline="true" class="demo-form-inline flex-align-between">
            <div class="formInline-left">
            </div>
            <div class="formInline-right flex-align-between">
                <div class="form-inline-item csp">
                    <i class="el-icon-circle-plus-outline"></i>
                    <span class="csp" @click="showCreateDialog = true;">上传成果</span>
                </div>
            </div>
        </el-form>

        <div class="table_section">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="number" label="序号" width="80" align="center" type="index" :index="indexMethod">
                </el-table-column>
                <el-table-column prop="name" label="成果名称" align="center">
                </el-table-column>
                <el-table-column prop="createTime" label="上传时间" align="center">
                </el-table-column>
                <el-table-column fixed="right" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button @click="editFile(scope.row)" type="text" size="small">编辑
                        </el-button>
                        <el-button type="text" size="small" @click="deleteProjectFile(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination :total="pages.total" :page.sync="pages.currentPage" :limit.sync="pages.pageSize"
                :pageSizes="[10,20,30]" @pagination="handlePageChange">
            </pagination>
        </div>
        <!-- </el-tab-pane>
            <el-tab-pane label="" name="second"></el-tab-pane>
        </el-tabs> -->
        <el-dialog :title="dialogTitle" :visible.sync="showCreateDialog" width="600px" @close="closeDialog"
            destroy-on-close>
            <el-form ref="createForm" :model="createForm" label-width="120px" :rules="rules">
                <el-form-item label="文件名称：" prop="name">
                    <el-input v-model.trim="createForm.name" size="mini" style="width:220px;" placeholder="请输入标题"
                        maxlength="30" show-word-limit></el-input>
                </el-form-item>

                <el-form-item label="上传附件：" prop="identifier">
                    <upload @uploadFile="handleFileChange" :name="'identifier'" :text="'上传成果'"
                        :list="editIdentifierList" AdjustTheType="ReviewManagement"/>
                </el-form-item>

                <el-form-item class="btns-box" label-width="0px">
                    <el-button class="submit btn" @click="onSubmit">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>

</template>

<script>
    import upload from './components/upload-file.vue';
    import {
        cloneDeep
    } from 'lodash/lang'

    export default {
        components: {
            upload
        },
        data() {
            return {
                activeName: "",
                rules: {
                    name: {
                        required: true,
                        message: "请输入文件名称",
                        trigger: "blur"
                    },
                },
                tableData: [],
                pages: { //分页
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                },
                showCreateDialog: false,
                createForm: {
                    name: undefined,
                    identifier: undefined,
                    type: 5,
                },
                dialogTitle: '上传成果',
                editIdentifierList: [],
            };
        },
        methods: {
            indexMethod(index) {
                return  this.pages.currentPage > 1 ?
                    (this.pages.pageSize * (this.pages.currentPage - 1)) + index + 1 :
                    index + 1
            },
            // 上传文件
            handleFileChange(data) {
                // console.log(data);
                // this.createForm[data.name] = data.fileMD5List[0];
                this.createForm[data.name] = data.fileMD5List;
                // Vue.delete(this.createForm, 'fileName');
                // if (JSON.stringify(data.fileMD5List) != '[]') {
                //     Vue.set(this.createForm, 'fileName', data.fileList[0].name);
                // }
            },
            // 翻页
            handlePageChange(data) {
                this.pages.currentPage = data.pageIndex
                this.pages.pageSize = data.pageSize
                this.getReviewList();
            },
            // 获取回顾列表
            async getReviewList() {
                let pramas = {
                    page: this.pages.currentPage,
                    limit: this.pages.pageSize,
                    projectId: this.$store.state.user.currentProject.id,
                    type: 5,
                }
                let resData = await this.$Api.Project.getProjectFileList(pramas);
                this.tableData = resData.data.records
                this.pages.total = resData.data.total
            },
            onSubmit() {
                this.$refs['createForm'].validate((valid) => {
                    // console.log('valid-------',valid);
                    if (valid) {
                        this.submitForm();
                    } else {
                        console.log('error')
                    }
                })
            },
            async submitForm() {
                let msg = undefined;
                let type = undefined;
                const rawId = this.createForm.identifier;
                const identifiers = Array.isArray(rawId)
                    ? rawId.filter((id) => id != null && id !== '')
                    : (rawId != null && rawId !== '' ? [rawId] : []);

                if (identifiers.length === 0) {
                    this.$message({ message: '请先上传附件', type: 'warning' });
                    return;
                }

                // console.log('this.createForm', this.createForm);

                const toStr = (id) => (typeof id === 'string' ? id : String(id));

                if (this.dialogTitle == '上传成果') {
                    let failCount = 0;
                    for (const identifier of identifiers) {
                        const payload = {
                            name: this.createForm.name,
                            projectId: this.createForm.projectId,
                            type: this.createForm.type,
                            identifier: toStr(identifier),
                        };
                        const resData = await this.$Api.Project.addProjectFile(payload);
                        // console.log('新建周报', resData);
                        if (resData.code != 200) failCount++;
                    }
                    msg =
                        failCount === 0
                            ? '上传成功'
                            : failCount === identifiers.length
                            ? '上传失败'
                            : `成功${identifiers.length - failCount}个，失败${failCount}个`;
                    type =
                        failCount === 0 ? 'success' : failCount === identifiers.length ? 'error' : 'warning';
                }
                if (this.dialogTitle != '上传成果') {
                    let failCount = 0;
                    for (const identifier of identifiers) {
                        const payload = {
                            ...this.createForm,
                            identifier: toStr(identifier),
                        };
                        const resData = await this.$Api.Project.editProjectFile(payload);
                        // console.log('编辑周报', resData);
                        const ok = resData.data && resData.data.code == 200;
                        if (!ok) failCount++;
                    }
                    msg =
                        failCount === 0
                            ? '编辑成功'
                            : failCount === identifiers.length
                            ? '编辑失败'
                            : `成功${identifiers.length - failCount}个，失败${failCount}个`;
                    type =
                        failCount === 0 ? 'success' : failCount === identifiers.length ? 'error' : 'warning';
                }
                this.$message({
                    message: msg,
                    type: type
                });
                this.getReviewList();
                this.showCreateDialog = false;
            },
            editFile(item) {
                this.createForm = cloneDeep(item);
                this.dialogTitle = `编辑${item.name}`
                this.editIdentifierList.push({
                    identifier: item.identifier,
                    filename: item.fileName
                });
                this.showCreateDialog = true;
            },
            closeDialog() {
                this.editIdentifierList = [];
                this.dialogTitle = '上传成果'
                Vue.set(this.createForm, 'name', undefined);
                Vue.set(this.createForm, 'identifier', undefined);
                Vue.delete(this.createForm, 'id');
                Vue.delete(this.createForm, 'createTime');
                Vue.delete(this.createForm, 'fileName');
            },

            // 删除
            deleteProjectFile(item) {
                this.$confirm(`是否删除${item.name}？`, "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        let params = {
                            id: item.id
                        }
                        console.log(params);
                        this.$Api.Project.deleteProjectFile(params).then((resData) => {
                            console.log(resData);
                            if (resData.code == 200) {
                                this.$message({
                                    message: "删除成功",
                                    type: "success"
                                });
                                this.getReviewList();
                            } else {
                                this.$message.error(resData.msg);
                            }
                        }).catch((err) => {
                            console.log(err);
                        })
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除"
                        });
                    });
            },
        },
        mounted() {
            this.getReviewList();
            Vue.set(this.createForm, 'projectId', this.$store.state.user.currentProject.id);
        },
    }
</script>

<style lang="less" scoped>
    @import "../manage/less/table.less";

    .reivew {
        padding: 20px 25px;
        box-sizing: border-box;

        /deep/ .el-dialog {
            border-radius: 10px;

            .el-dialog__header {
                border-bottom: 1px solid #E4E4E4;
                padding: 15px 31px 10px;
            }

            .el-dialog__title {
                font-size: 15px;
                color: #333;

                &::before {
                    content: '';
                    width: 5px;
                    height: 17px;
                    background-color: #01A2FD;
                    display: inline-block;
                    margin-right: 14px;
                    vertical-align: -3px;
                    border-radius: 3px;
                }
            }

            .el-dialog__headerbtn {
                top: 15px;
            }

            .btns-box {
                text-align: center;
            }

            .submit {
                background: linear-gradient(180deg, #5DA7FF 0%, #4893F9 100%);
                border-radius: 25px;
                color: #fff;
                line-height: 35px;
                padding: 0 63px;
                cursor: pointer;
                border: 0;

                &:hover {
                    background: linear-gradient(180deg, rgba(93, 167, 255, .8) 0%, rgba(72, 147, 249, .8) 100%);
                }
            }
        }
    }
</style>